export { default } from "./PromoModal";
